import Base from "components/Creation/components/Base";
import { useEffect, useState } from "react";
import useSelection from "hooks/useSelection";
import { useSelector } from "react-redux";
import moment from "moment";
import { Animated } from "react-animated-css";

const Budget = () => {
  const currentSelection = useSelector((state) => state.booking.selection);
  const [duration, setDuration] = useState(0);
  const [selected, setSelected] = useState(null);
  const { setSelectionForKey, redirectIfNotValidUpUntilKey, keyIsValidated } =
    useSelection({
      key: "budget",
      setter: setSelected,
    });
  const [budgetOptions, setBudgetOptions] = useState([
    {
      title: "£25",
      value: "25",
      disabled: true,
    },
    {
      title: "£50",
      value: "50",
    },
    {
      title: "£75",
      value: "75",
    },
    {
      title: "£75+",
      value: "75+",
    },
  ]);

  const gridColsClassName = `grid-cols-5`; //${BUDGET_OPTIONS.length + 1} doesnt always work with Tailwind

  const handleOptionClick = ({ option }) => {
    setSelectionForKey(option.value);
  };

  const getDurationOfBooking = (startTime, endTime) => {
    let dummyDate = moment();

    let start = dummyDate
      .clone()
      .set({ hour: startTime.split(":")[0], minute: startTime.split(":")[1] });
    let end = dummyDate
      .clone()
      .set({ hour: endTime.split(":")[0], minute: endTime.split(":")[1] });
    let duration = moment.duration(end.diff(start));

    let hours = duration.asHours();
    if (hours < 0) {
      hours = hours + 24;
    }
    return hours;
  };

  useEffect(() => {
    redirectIfNotValidUpUntilKey("budget");
  }, []);

  useEffect(() => {
    if (currentSelection.when?.startTime && currentSelection.when?.endTime) {
      console.log(
        "getDurationOfBooking",
        getDurationOfBooking(
          currentSelection.when.startTime,
          currentSelection.when.endTime
        )
      );
      setDuration(
        getDurationOfBooking(
          currentSelection.when.startTime,
          currentSelection.when.endTime
        )
      );
    }
  }, [currentSelection]);

  useEffect(() => {
    let newBudgetOptions = [...budgetOptions];
    if (duration > 2.5) {
      newBudgetOptions[0].disabled = true;
    } else {
      newBudgetOptions[0].disabled = false;
    }
    setBudgetOptions(newBudgetOptions);
    if (duration > 2.5 && selected === "25") {
      setSelectionForKey("50");
    }
  }, [duration]);

  return (
    <Base
      className="mirum-page-budget"
      title="Budget"
      infoBody="select the amount you’d like to allocate per person. budget limits have been applied based on the selected duration of your surprise."
    >
      <div className="flex flex-col w-11/12 mx-auto h-full z-10 flex-grow">
        <div className="flex-grow flex items-center">
          <div className="container mx-auto">
            <div className="w-full">
              <div className={`md:grid ${gridColsClassName}`}>
                <div className="hidden md:block text-center md:text-right pr-4 mb-4 md:mb-0">
                  {/* <h1>{duration}&nbsp;hours</h1> */}
                  <h2>up to*:</h2>
                  <h4>(per person)</h4>
                </div>
                {budgetOptions.map((option, index) => {
                  return (
                    <div
                      className={`${
                        option.disabled && "hidden md:block opacity-25"
                      } md:mirum-option cursor-pointer ${
                        selected === option.value ? "selected" : ""
                      }`}
                      onClick={() => {
                        if (!option.disabled) {
                          handleOptionClick({ option });
                        }
                      }}
                    >
                      <div
                        key={index}
                        className="mirum-budget-item transition-all w-full h-16 flex items-center text-center justify-center"
                      >
                        <h3>{option.title}</h3>
                        <br />
                      </div>
                      {option.disabled && (
                        <small className="p-4 block w-full text-center lowercase">
                          Not available for a duration of over 2.5h
                        </small>
                      )}
                    </div>
                  );
                })}
              </div>
              <h3 className="md:hidden text-center mt-4">(max. per person*)</h3>
              <p className="mt-4 md:mt-0 md:w-11/12 mx-auto md:pl-8">
                *budget selection should be taken as a guidance only, due to
                individual preferences. in some instances, prepayment will be
                required, therefore it is your responsibility to ensure you have
                the adequate funds in the payment instrument you have provided
                us. you will be notified in advance via text message when a
                prepayment is required
              </p>
            </div>
          </div>
        </div>
      </div>
    </Base>
  );
};

export default Budget;
